import authService from "../services/authService";
import { useMutation } from "react-query";

const useLoginMutation = (onData) => {
  return useMutation(authService.login, {
    onSuccess: (data) => onData(data),
  });
};

const useUserList = (onData) => {
  return useMutation(authService.userList, {
    onSuccess: (data) => onData(data),
  });
};

const useCreateUser = (onData) => {
  return useMutation(authService.createUser, {
    onSuccess: (data) => onData(data),
  });
};

const useUpdateUser = (onData) => {
  return useMutation(authService.updateUser, {
    onSuccess: (data) => onData(data),
  });
};

const useChangePassword = (onData) => {
  return useMutation(authService.changePassword, {
    onSuccess: (data) => onData(data),
  });
};

const useDeleteUser = (onData) => {
  return useMutation(authService.deleteUser, {
    onSuccess: (data) => onData(data),
  });
};

const authQueries = {
    useLoginMutation,
    useUserList,
    useCreateUser,
    useUpdateUser,
    useChangePassword,
    useDeleteUser
};

export default authQueries;
